import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const faqs = [{
    q: 'Mi hijo solo come fideos, ¿va a comer esto?',
    a: 'Sí. El protocolo reduce la inflamación que causa la selectividad. A medida que sana su intestino, su hambre real vuelve de forma natural, sin forzar.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No. El 90% del protocolo se compra en la dietética de tu barrio o en el mercado local. Está diseñado para la economía real de Latinoamérica.'
  }, {
    q: '¿Cuánto tiempo tarda en funcionar?',
    a: 'Verás cambios digestivos (desinflamación, mejor sueño, evacuación) en los primeros 7 días. La conexión visual profunda suele aparecer entre la semana 4 y 12.'
  }, {
    q: '¿Qué pasa si me salgo de la dieta?',
    a: 'Es como una alergia; los síntomas regresan porque el cuerpo vuelve a intoxicarse. Por eso el libro te enseña a hacerlo un estilo de vida rico, fácil y sostenible para toda la familia.'
  }];
  return <section className="py-20 bg-brand-cream" data-id="element-37">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-teal mb-4" data-id="element-40">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-41">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, idx) => <div key={idx} className={`bg-white rounded-xl border transition-all duration-200 ${openIdx === idx ? 'border-brand-gold shadow-md' : 'border-gray-200 hover:border-brand-teal/30'}`} data-id="element-43">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} aria-expanded={openIdx === idx} data-id="element-44">
                <span className="font-bold text-brand-dark pr-4" data-id="element-45">{faq.q}</span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-brand-gold shrink-0" data-id="element-46" /> : <ChevronDown className="w-5 h-5 text-gray-400 shrink-0" data-id="element-47" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-48">
                <p className="text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-49">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}